export function ViolationTypeDescription(data) {
    const { id, text: description, link, foulTypesFiles: files } = data;

    return {
        id,
        description: description || "",
        link: link || "",
        files: (files || []).map((file) => {
            const { id, name } = file;

            return {
                id,
                url: name,
                name: name.split("/").pop(),
            };
        }),
        hasDescription: description || link || (files && files.length),
    };
}

export function ViolationType(data) {
    const {
        id,
        description: name,
        is_important: important,
        category_id: group,
        points,
        foulTypePosts: positions,
    } = data;

    return {
        id,
        name: name || "",
        important: !!Number(important),
        group,
        points: points || "",
        positions,

        ...ViolationTypeDescription(data),
    };
}

export function formatViolationType(data) {
    const { id, name, description, link, important, group, points, positions, files, oldFiles } = data;

    const params = {
        description: name,
        category_id: group,
        post_code: positions,
        points,
        is_important: important ? 1 : 0,
        files,
        oldFiles,
        text: description,
        link,
    };

    if (id) params.id = id;

    return params;
}
